import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public oidcSecurityService: OidcSecurityService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Insert ID Token from Digital Pass in API request
    if (request.url.startsWith(`${environment.apiUrl}`)) {
      const tokenOb$ = this.oidcSecurityService.getIdToken();

      tokenOb$.pipe(take(1)).subscribe(token => {          
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
      });

    }
    return next.handle(request);
  }
}
